import { render, staticRenderFns } from "./odemesekliaciklama.vue?vue&type=template&id=c2aa2cdc&"
import script from "./odemesekliaciklama.vue?vue&type=script&lang=js&"
export * from "./odemesekliaciklama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports